import CRUDTableComponent from '../../components/CRUDTableComponent'

const CommunesTable = () => {
  const tableColumns = [
    {
      title: 'ID',
      dataIndex: 'id',
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      type: 'string',
      filter: true,
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
  ]

  return (
    <CRUDTableComponent
      entityName={{ singular: 'Comuna', plural: 'Comunas' }}
      tableColumns={tableColumns}
      entityUrl="/communes?sortBy=name"
    />
  )
}

export default CommunesTable
